import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './breadcrumbs.component.html'
})
export class BreadcrumbsComponent {

}
